import { SentryConfigured } from './SentryConfigured';

type SentrySetUserProps = {
  clientId: string;
};
export const sentrySetUser = ({ clientId }: SentrySetUserProps) => {
  if (clientId) {
    SentryConfigured.setUser({ id: clientId });
  }

  SentryConfigured.setUser(null);
};
